import React, { useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

const FinancialReportGrid = () => {
  const gridStyle = useMemo(() => ({ height: 600, width: "100%" }), []);

  const rowData = [
    {
      account: "01 printing and Stationery expenses",
      initialBalance: 0,
      debit: 200,
      credit: 0,
      endBalance: 200,
    },
    {
      account: "101300 Account Receivable (PoS)",
      initialBalance: 0,
      debit: 260.7,
      credit: 175.85,
      endBalance: 84.85,
    },
    {
      account: "101401 Bank 1",
      initialBalance: 6378,
      debit: 6099.35,
      credit: 3548.38,
      endBalance: 12944.87,
    },
    {
      account: "101402 Bank Suspense Account",
      initialBalance: -6378,
      debit: 0,
      credit: 0,
      endBalance: -6378,
    },
    {
      account: "101501 Cash Furn. Shop",
      initialBalance: 0,
      debit: 2243.57,
      credit: 0,
      endBalance: 2243.57,
    },
  ];

  const cellStyle = (params: any) => {
    if (params.value < 0) {
      return { color: "red" }
    }

    return null;
  };

  const columnDefs = [
    {
      headerName: "",
      children: [{ field: "account", headerName: "Account" }],
    },
    {
      headerName: "Initial Balance",
      children: [
        { field: "initialBalance", headerName: "Balance", aggFunc: "sum", cellStyle },
      ],
    },
    {
      headerName: "Apr 2025",
      children: [
        { field: "debit", headerName: "Debit", aggFunc: "sum" },
        { field: "credit", headerName: "Credit", aggFunc: "sum" },
      ],
    },
    {
      headerName: "End Balance",
      children: [
        { field: "endBalance", headerName: "Balance", aggFunc: "sum", cellStyle },
      ],
    },
  ];

  const defaultColDef = useMemo(() => ({
    flex: 1,
    resizable: true,
    sortable: true,
    filter: true,
  }), []);

  return (
    <div className="web-report-container">
      <div className="web-report">
        <div className="grid-continer" style={gridStyle}>
          <AgGridReact
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            grandTotalRow="bottom"
            theme={themeBalham}
            rowSelection="single"
          />
        </div>
      </div>
    </div>
  );
};

export default FinancialReportGrid;


